<template>
  <div>
    <el-row :gutter="10">
      <el-col :md="3" :lg="3" class="no-wrap">
        <el-button type="primary" size="medium" @click="addDialogShow">新建到店签到活动</el-button>
      </el-col>
    </el-row>
    <el-alert
      class="rule-alert"
      type="warning"
      :closable="false"
      show-icon
      title="小程序端同一时刻只有一个活动对外生效"
      description="生效规则：状态为「启用」 + 当前时间落在活动时间范围内 + 创建时间最新。同时启用多个活动时，其余活动不会生效。另：活动时间留空时，开始时间取当前时间、结束时间取当年 12-31 23:59:59，跨年后需延长结束时间，否则活动会静默失效。">
    </el-alert>
    <el-table
      :data="tableData"
      style="width: 100%"
      v-loading="loading">
      <el-table-column
        fixed
        prop="id"
        label="序号"
        width="80">
      </el-table-column>
      <el-table-column
        prop="name"
        label="活动名称"
        width="auto">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
          <el-tag v-if="scope.row.id === currentActiveId" class="active-tag" type="success" size="mini">当前生效</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="开始时间"
        width="170">
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="结束时间"
        width="170">
      </el-table-column>
      <el-table-column
        prop="distance_threshold"
        label="到店距离阈值(米)"
        width="140">
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status=='1'" type="success">启用</el-tag>
          <el-tag v-else type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        width="170">
      </el-table-column>
      <el-table-column
        label="操作"
        width="180">
        <template slot-scope="scope">
          <el-button @click="detailDialogShow(scope.row)" type="text" size="small">查看</el-button>
          <el-button type="text" size="small" @click="editDialogShow(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="delActivity(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > searchParams.pagesize" class="content-padded content-center">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="searchParams.page"
        :total="total_count" :page-size="searchParams.pagesize">
      </el-pagination>
    </div>

    <!--------------------- 新建到店签到活动 ------------------------>
    <el-dialog title="新建到店签到活动" width="80%" :visible.sync="addDialog">
      <el-form :model="addData" label-width="140px">
        <el-form-item label="活动名称">
          <el-col :span="10">
            <el-input v-model="addData.name" autocomplete="off" placeholder="请输入活动名称"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-col :span="10">
            <el-date-picker
              v-model="addData.timeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-col>
          <el-col :span="10" class="frm-tips">不选择则开始时间取当前时间、结束时间取当年 12-31 23:59:59</el-col>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-col :span="10">
            <el-switch
              v-model="addData.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="2">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="到店距离阈值">
          <el-col :span="5">
            <el-input v-model="addData.distance_threshold" @input="handleThresholdInt('add')"></el-input>
          </el-col>
          <el-col :span="12" class="frm-tips">单位：米。会员与门店的距离需小于等于该值才可签到</el-col>
        </el-form-item>
        <el-form-item label="到店签到图片">
          <div class="upload-box" @click="handleImgPicker('daily_sign_img')">
            <img v-if="addData.daily_sign_img" :src="addData.daily_sign_img" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
          </div>
          <div class="frm-tips">注：签到图标图片，只能上传jpg/png文件，且不超过500KB</div>
        </el-form-item>
        <el-form-item label="连续签到奖励"></el-form-item>
        <el-form-item v-for="(item, index) in addData.award" :key="index">
          <el-col :span="1.5" class="form-label">类型：</el-col>
          <el-col :span="3">
            <el-select v-model="item.award_type" placeholder="请选择" size="small">
              <el-option
                v-for="opt in awardOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="1.5" class="form-label">连续天数：</el-col>
          <el-col :span="2">
            <el-input v-model="item.period_num" size="small" placeholder="如 3"></el-input>
          </el-col>
          <el-col :span="1.5" class="form-label">奖励内容：</el-col>
          <el-col :span="4">
            <el-input v-model="item.award_content" size="small" :placeholder="item.award_type==='points' ? '积分数' : '优惠券ID'"></el-input>
          </el-col>
          <el-col :span="1.5" class="form-label">描述：</el-col>
          <el-col :span="3">
            <el-input v-model="item.award_description" size="small" placeholder="请输入奖品描述"></el-input>
          </el-col>
          <el-col :span="1.5" class="form-label">展示图片：</el-col>
          <el-col :span="2">
            <div class="upload-box upload-box-mini" @click="handleImgPicker('continuous_sign_img', index)">
              <img v-if="item.image" :src="item.image" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
          </el-col>
          <el-col :span="2">
            <el-button @click.prevent="removeAward(item)" size="small" type="danger">删除</el-button>
          </el-col>
        </el-form-item>
        <el-button @click="addPeriod" type="text" size="small">新增连续签到奖励</el-button>
        <div class="frm-tips award-tips">注：连续天数从 1 开始配置，「连续第 1 天」即每次到店签到的基础奖励，必须配置，否则会员签到后拿不到任何奖励；奖励类型选「积分」时奖励内容填积分数量，选「优惠券」时填卡券ID（小程序端凭该ID发券）。</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="newActivity" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!--------------------- 编辑到店签到活动 ------------------------>
    <el-dialog title="编辑到店签到活动" width="80%" :visible.sync="editDialog">
      <el-form :model="editData" label-width="140px">
        <el-form-item label="活动名称">
          <el-col :span="10">
            <el-input v-model="editData.name" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-col :span="10">
            <el-date-picker
              v-model="editData.timeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-col>
          <el-col :span="10" class="frm-tips">不选择则开始时间取当前时间、结束时间取当年 12-31 23:59:59；活动仅在该时间范围内对小程序端生效</el-col>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-col :span="10">
            <el-switch
              v-model="editData.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="2">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="到店距离阈值">
          <el-col :span="5">
            <el-input v-model="editData.distance_threshold" @input="handleThresholdInt('edit')"></el-input>
          </el-col>
          <el-col :span="12" class="frm-tips">单位：米。会员与门店的距离需小于等于该值才可签到</el-col>
        </el-form-item>
        <el-form-item label="到店签到图片">
          <div class="upload-box" @click="handleImgPicker('daily_sign_img')">
            <img v-if="editData.daily_sign_img" :src="editData.daily_sign_img" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
          </div>
          <div class="frm-tips">注：签到图标图片，只能上传jpg/png文件，且不超过500KB</div>
        </el-form-item>
        <el-form-item label="连续签到奖励"></el-form-item>
        <el-form-item v-for="(item, index) in editData.award" :key="index">
          <el-col :span="1.5" class="form-label">类型：</el-col>
          <el-col :span="3">
            <el-select v-model="item.award_type" placeholder="请选择" size="small">
              <el-option
                v-for="opt in awardOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="1.5" class="form-label">连续天数：</el-col>
          <el-col :span="2">
            <el-input v-model="item.period_num" size="small" placeholder="如 3"></el-input>
          </el-col>
          <el-col :span="1.5" class="form-label">奖励内容：</el-col>
          <el-col :span="4">
            <el-input v-model="item.award_content" size="small" :placeholder="item.award_type==='points' ? '积分数' : '优惠券ID'"></el-input>
          </el-col>
          <el-col :span="1.5" class="form-label">描述：</el-col>
          <el-col :span="3">
            <el-input v-model="item.award_description" size="small" placeholder="请输入奖品描述"></el-input>
          </el-col>
          <el-col :span="1.5" class="form-label">展示图片：</el-col>
          <el-col :span="2">
            <div class="upload-box upload-box-mini" @click="handleImgPicker('continuous_sign_img', index)">
              <img v-if="item.image" :src="item.image" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
          </el-col>
          <el-col :span="2">
            <el-button @click.prevent="removeEditAward(item)" size="small" type="danger">删除</el-button>
          </el-col>
        </el-form-item>
        <el-button @click="addEditPeriod" type="text" size="small">新增连续签到奖励</el-button>
        <div class="frm-tips award-tips">注：连续天数从 1 开始配置，「连续第 1 天」即每次到店签到的基础奖励，必须配置，否则会员签到后拿不到任何奖励；奖励类型选「积分」时奖励内容填积分数量，选「优惠券」时填卡券ID（小程序端凭该ID发券）。</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editActivity" :loading="btnLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!--------------------- 查看到店签到活动 ------------------------>
    <el-dialog title="查看到店签到活动" width="80%" :visible.sync="viewDialog">
      <el-form :model="detailData" label-width="140px">
        <el-form-item label="活动名称">
          <el-col :span="10">
            <el-input v-model="detailData.name" disabled></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-col :span="10">
            <el-input v-model="detailData.start_time" disabled></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-col :span="10">
            <el-input v-model="detailData.end_time" disabled></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-col :span="10">
            <el-tag v-if="detailData.status=='1'" type="success">启用</el-tag>
            <el-tag v-else type="info">禁用</el-tag>
          </el-col>
        </el-form-item>
        <el-form-item label="到店距离阈值">
          <el-col :span="10">
            <el-input :value="detailData.distance_threshold + ' 米'" disabled></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="到店签到图片">
          <div class="upload-box upload-box-view">
            <img v-if="detailData.daily_sign_img" :src="detailData.daily_sign_img" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
          </div>
        </el-form-item>
        <el-form-item label="奖励配置"></el-form-item>
        <el-table :data="detailData.award" border size="small">
          <el-table-column prop="day" label="连续天数" width="100"></el-table-column>
          <el-table-column prop="award_type" label="奖励类型" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.award_type=='points'">积分</el-tag>
              <el-tag v-else type="warning">优惠券</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="award_content" label="奖励内容" width="120"></el-table-column>
          <el-table-column prop="award_description" label="描述"></el-table-column>
          <el-table-column prop="image" label="展示图片" width="100">
            <template slot-scope="scope">
              <img v-if="scope.row.image" :src="scope.row.image" class="award-img"/>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialog = false">关 闭</el-button>
      </div>
    </el-dialog>

    <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
  </div>
</template>

<script>
import imgPicker from '@/components/imageselect'
import {
  getStoreSigninActivityList,
  addStoreSigninActivity,
  editStoreSigninActivity,
  delStoreSigninActivity
} from '../../../api/store_sign'

// 后端返回的时间为 'Y-m-d H:i:s' 字符串，Safari/iOS 下需将 '-' 换成 '/' 才能正确解析
function toTime (str) {
  if (!str) {
    return 0
  }
  var t = new Date(String(str).replace(/-/g, '/')).getTime()
  return isNaN(t) ? 0 : t
}

// 后端 prepareAwardData 会对 award 的每一项做 json_decode，
// 因此提交时每项必须是 JSON 字符串，而不是对象。
function buildAwardParams (awardList) {
  return (awardList || []).map(function (item) {
    return JSON.stringify({
      award_type: item.award_type,
      award_content: item.award_content,
      award_description: item.award_description,
      period_num: item.period_num,
      image: item.image || ''
    })
  })
}

export default {
  components: {
    imgPicker
  },

  data () {
    return {
      loading: false,
      btnLoading: false,
      tableData: [],
      total_count: 0,
      searchParams: {
        page: 1,
        pagesize: 10
      },
      addDialog: false,
      editDialog: false,
      viewDialog: false,
      // 小程序端当前实际生效的活动ID
      currentActiveId: 0,
      // 图片选择器状态
      imgDialog: false,
      isGetImage: false,
      pickerImgType: '',
      credential_url_index: 0,
      addData: {
        name: '',
        timeRange: '',
        start_time: '',
        end_time: '',
        status: '1',
        distance_threshold: '',
        daily_sign_img: '',
        award: []
      },
      editData: {
        id: '',
        name: '',
        timeRange: '',
        start_time: '',
        end_time: '',
        status: '1',
        distance_threshold: '',
        daily_sign_img: '',
        award: []
      },
      detailData: {
        name: '',
        start_time: '',
        end_time: '',
        status: '1',
        distance_threshold: '',
        daily_sign_img: '',
        award: []
      },
      awardOptions: [
        { value: 'points', label: '积分' },
        { value: 'coupon', label: '优惠券' }
      ]
    }
  },

  methods: {
    getList () {
      this.loading = true
      getStoreSigninActivityList(this.searchParams).then(res => {
        this.loading = false
        if (res.data.data && res.data.data.list) {
          // 后端返回的时间为格式化字符串、status 为数字，这里只做兜底转换
          this.tableData = res.data.data.list.map(function (item) {
            return Object.assign({}, item, {
              status: String(item.status)
            })
          })
          this.total_count = res.data.data.total_count
        } else {
          this.tableData = []
          this.total_count = 0
        }
      }).catch(() => {
        this.loading = false
      })
    },

    // 小程序端（getStoreSigninStatus / getStoreSignActivityData）只会取
    // 「启用中 + 当前时间在活动期内 + 创建时间最新」的那一个活动，
    // 这里复现同样的判定，用于在列表上标注真正对外生效的活动。
    loadCurrentActiveId () {
      getStoreSigninActivityList({ page: 1, pagesize: 100 }).then(res => {
        var data = res.data.data
        if (!data || !data.list || !data.list.length) {
          this.currentActiveId = 0
          return
        }
        // 活动总数超出单次拉取量时无法保证判定准确，此时不做标注
        if (Number(data.total_count) > data.list.length) {
          this.currentActiveId = 0
          return
        }
        var now = Date.now()
        var hit = data.list.filter(function (item) {
          if (String(item.status) !== '1') {
            return false
          }
          return toTime(item.start_time) <= now && toTime(item.end_time) >= now
        })
        if (!hit.length) {
          this.currentActiveId = 0
          return
        }
        hit.sort(function (a, b) {
          return toTime(b.create_time) - toTime(a.create_time)
        })
        this.currentActiveId = hit[0].id
      }).catch(() => {
        this.currentActiveId = 0
      })
    },

    addDialogShow () {
      this.addData = {
        name: '',
        timeRange: '',
        start_time: '',
        end_time: '',
        status: '1',
        distance_threshold: '',
        daily_sign_img: '',
        award: []
      }
      this.addDialog = true
    },

    editDialogShow (row) {
      var awardList = (row.award || [])
        .map(function (a) {
          return {
            award_type: a.award_type,
            award_content: a.award_content,
            award_description: a.award_description,
            period_num: String(a.period_num),
            // 后端 editParams 会先删除再重建奖励配置，不回显 image 会导致奖品图丢失
            image: a.image || ''
          }
        })

      this.editData = {
        id: row.id,
        name: row.name,
        timeRange: [row.start_time, row.end_time],
        start_time: row.start_time,
        end_time: row.end_time,
        status: String(row.status),
        distance_threshold: row.distance_threshold,
        daily_sign_img: row.daily_sign_img || '',
        award: awardList
      }
      this.editDialog = true
    },

    detailDialogShow (row) {
      this.detailData = {
        name: row.name,
        start_time: row.start_time,
        end_time: row.end_time,
        status: String(row.status),
        distance_threshold: row.distance_threshold,
        daily_sign_img: row.daily_sign_img || '',
        award: row.award || []
      }
      this.viewDialog = true
    },

    // 校验连续签到奖励。后端不再自动生成任何奖励档位，
    // 「连续第 1 天」缺失会导致会员签到后拿不到基础奖励，故强制要求配置。
    validateAward (awardList) {
      var seen = {}
      for (var i = 0; i < awardList.length; i++) {
        var item = awardList[i]
        if (!item.period_num) {
          this.$message({ showClose: true, message: '连续天数不能为空', type: 'error' })
          return false
        }
        var day = Number(item.period_num)
        if (!Number.isInteger(day) || day < 1) {
          this.$message({ showClose: true, message: '连续天数需为不小于 1 的整数', type: 'error' })
          return false
        }
        if (seen[day]) {
          this.$message({ showClose: true, message: '连续天数 ' + day + ' 重复设置', type: 'error' })
          return false
        }
        seen[day] = true
        if (!item.award_content) {
          this.$message({ showClose: true, message: '奖励内容不能为空', type: 'error' })
          return false
        }
      }
      if (!seen[1]) {
        this.$message({ showClose: true, message: '请补充「连续第 1 天」的奖励，否则会员签到后拿不到基础奖励', type: 'error' })
        return false
      }
      return true
    },

    newActivity () {
      if (!this.addData.name) {
        this.$message({ showClose: true, message: '请填写活动名称', type: 'error' })
        return
      }
      var awardList = this.addData.award || []
      if (!awardList.length) {
        this.$message({ showClose: true, message: '请至少配置一档连续签到奖励', type: 'error' })
        return
      }
      if (!this.validateAward(awardList)) {
        return
      }

      var param = {
        name: this.addData.name,
        status: this.addData.status,
        distance_threshold: this.addData.distance_threshold,
        daily_sign_img: this.addData.daily_sign_img,
        award: buildAwardParams(awardList)
      }
      // 不传时间时后端兜底：开始时间取当前时间、结束时间取当年 12-31 23:59:59
      if (this.addData.timeRange && this.addData.timeRange.length > 1) {
        param.start_time = this.addData.timeRange[0]
        param.end_time = this.addData.timeRange[1]
      }

      this.btnLoading = true
      addStoreSigninActivity(param).then(res => {
        this.btnLoading = false
        this.$message({ showClose: true, message: '活动已创建！', type: 'success' })
        this.addDialog = false
        this.getList()
        this.loadCurrentActiveId()
      }).catch(() => {
        this.btnLoading = false
      })
    },

    editActivity () {
      if (!this.editData.name) {
        this.$message({ showClose: true, message: '请填写活动名称', type: 'error' })
        return
      }
      var awardList = this.editData.award || []
      if (!awardList.length) {
        this.$message({ showClose: true, message: '请至少配置一档连续签到奖励', type: 'error' })
        return
      }
      if (!this.validateAward(awardList)) {
        return
      }

      var param = {
        id: this.editData.id,
        name: this.editData.name,
        status: this.editData.status,
        distance_threshold: this.editData.distance_threshold,
        daily_sign_img: this.editData.daily_sign_img,
        award: buildAwardParams(awardList)
      }
      if (this.editData.timeRange && this.editData.timeRange.length > 1) {
        param.start_time = this.editData.timeRange[0]
        param.end_time = this.editData.timeRange[1]
      }

      this.btnLoading = true
      editStoreSigninActivity(param).then(res => {
        this.btnLoading = false
        this.$message({ showClose: true, message: '活动已修改！', type: 'success' })
        this.editDialog = false
        this.getList()
        this.loadCurrentActiveId()
      }).catch(() => {
        this.btnLoading = false
      })
    },

    delActivity (row) {
      this.$confirm('确定删除活动「' + row.name + '」吗？删除后不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delStoreSigninActivity(row.id).then(res => {
          this.$message({ showClose: true, message: '活动已删除', type: 'success' })
          this.getList()
          this.loadCurrentActiveId()
        })
      }).catch(() => {})
    },

    addPeriod () {
      if (this.addData.award.length >= 5) {
        this.$message({ showClose: true, message: '连续签到奖励不能多于5个', type: 'warning' })
        return
      }
      this.addData.award.push({
        period_num: '',
        award_type: 'points',
        award_content: '',
        award_description: '',
        image: ''
      })
    },

    addEditPeriod () {
      if (this.editData.award.length >= 5) {
        this.$message({ showClose: true, message: '连续签到奖励不能多于5个', type: 'warning' })
        return
      }
      this.editData.award.push({
        period_num: '',
        award_type: 'points',
        award_content: '',
        award_description: '',
        image: ''
      })
    },

    removeAward (item) {
      var index = this.addData.award.indexOf(item)
      if (index !== -1) {
        this.addData.award.splice(index, 1)
      }
    },

    removeEditAward (item) {
      var index = this.editData.award.indexOf(item)
      if (index !== -1) {
        this.editData.award.splice(index, 1)
      }
    },

    handleCurrentChange (val) {
      this.searchParams.page = val
      this.getList()
    },

    handleThresholdInt (type) {
      var data = type === 'add' ? this.addData : this.editData
      data.distance_threshold = String(data.distance_threshold).replace(/[^\d]/g, '')
    },

    // 打开图片选择器，pickerImgType 区分「活动签到图」与「奖励展示图」
    handleImgPicker (pickerImgType, index = 0) {
      this.pickerImgType = pickerImgType
      this.credential_url_index = index
      this.imgDialog = true
      this.isGetImage = true
    },

    pickImg (data) {
      if (this.pickerImgType === 'continuous_sign_img') {
        if (this.addDialog) {
          this.addData.award[this.credential_url_index].image = data.url
        } else if (this.editDialog) {
          this.editData.award[this.credential_url_index].image = data.url
        }
      } else {
        if (this.addDialog) {
          this.addData[this.pickerImgType] = data.url
        } else if (this.editDialog) {
          this.editData[this.pickerImgType] = data.url
        }
      }
      this.imgDialog = false
    },

    closeImgDialog () {
      this.imgDialog = false
      this.isGetImage = false
    }
  },

  mounted () {
    this.getList()
    this.loadCurrentActiveId()
  }
}
</script>

<style scoped lang="scss">
.no-wrap {
  white-space: nowrap;
}
.rule-alert {
  margin: 10px 0;
}
.active-tag {
  margin-left: 6px;
}
.frm-tips {
  color: #999;
  font-size: 12px;
  line-height: 20px;
  padding-left: 10px;
}
.form-label {
  color: #409eff;
}
.award-tips {
  padding-left: 0;
  margin-top: 5px;
}
.upload-box {
  display: inline-block;
  width: 150px;
  height: 150px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  &:hover {
    border-color: #409eff;
  }
  .avatar {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .avatar-uploader-icon {
    font-size: 38px;
    color: #8c939d;
    line-height: 148px;
  }
}
.upload-box-mini {
  width: 60px;
  height: 32px;
  border-radius: 4px;
  .avatar {
    object-fit: contain;
  }
  .avatar-uploader-icon {
    font-size: 18px;
    line-height: 30px;
  }
}
.upload-box-view {
  cursor: default;
  &:hover {
    border-color: #c0ccda;
  }
}
.award-img {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.el-date-editor .el-range-separator {
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// list.vue?2a8a6de5